import React from 'react';
import styled from '@emotion/styled';
import { Image, Input, Avatar } from '@atomic';
import { COLOR_BORDER } from '@assets/color';
import { MediaQueries, BREAKPOINT_PHONE } from '@style/MediaQuery';
import LogoTypoUrl from '@assets/logo/logo_typo.svg';
import LogoUrl from '@assets/logo/logo.svg';
import { Link } from 'react-router-dom';
import { useUserContext } from '@contexts/UserContext/UserProvider';

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 10px;
  gap: 30px;
`;

const LogoContainer = styled(Image)`
  display: none;
  width: 40px;
  min-width: 40px;

  ${MediaQueries(BREAKPOINT_PHONE)} {
    display: block;
  }
`;

const TypoLogoContainer = styled(Image)`
  width: 75px;
  height: 32px;
  min-width: 75px;

  ${MediaQueries(BREAKPOINT_PHONE)} {
    display: none;
  }
`;

const SearchContainer = styled.div`
  width: 100%;
  max-width: 560px;
  height: 45px;
  display: flex;
  object-fit: contain;

  ${MediaQueries(BREAKPOINT_PHONE)} {
    display: none;
  }
`;

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Header = () => {
  const { currentUser } = useUserContext();
  const { uid, coverImage } = currentUser;

  return (
    <HeaderWrapper>
      <Link to={{ pathname: '/' }}>
        <LogoContainer src={LogoUrl} />
        <TypoLogoContainer src={LogoTypoUrl} />
      </Link>
      <SearchContainer>
        <Input
          inputType="form"
          name="headerInput"
          type="text"
          textSize={16}
          placeholder="SEARCH..."
          style={{ border: `1px solid ${COLOR_BORDER}` }}
        />
      </SearchContainer>
      <AvatarContainer>
        <Link
          to={{
            pathname: `/profile/${uid}`,
            state: { userInfo: currentUser },
          }}
        >
          <Avatar borderSize={43} avatarUrl={coverImage} />
        </Link>
      </AvatarContainer>
    </HeaderWrapper>
  );
};

export default Header;
